/* Reference-media selection; native Dawn remains responsible for price, variant ID and cart. */
(() => {
  const latest = new Map();
  function activate(root, preferred) {
    const inputs = [...root.querySelectorAll('variant-selects input:checked[data-lumis-group]')];
    const pick = group => inputs.find(input => input.dataset.lumisGroup === group);
    let mediaId;
    const composition = pick('configuration');
    const cable = pick('cable');
    if (composition) {
      // Multi-lamp reference images take precedence; never depict a Solo as a selected Duo/Trio.
      mediaId = composition.dataset.lumisValue === 'solo' && cable?.dataset.lumisMedia
        ? cable.dataset.lumisMedia : composition.dataset.lumisMedia;
    } else if (pick('length')) {
      const length = pick('length').value.match(/\d+/)?.[0];
      const pack = pick('pack')?.value || '';
      const qty = /3/.test(pack) ? 'lot de 3' : /2/.test(pack) ? 'lot de 2' : 'unité';
      const media = [...root.querySelectorAll('media-gallery .product__media-item')].find(item => {
        const alt = item.querySelector('img')?.alt.toLowerCase() || '';
        return alt.includes(length + ' mm') && alt.includes(qty);
      });
      mediaId = media?.dataset.mediaId?.split('-').at(-1);
    } else {
      mediaId = inputs.find(input => input.dataset.lumisGroup === preferred)?.dataset.lumisMedia;
    }
    const gallery = root.querySelector('media-gallery');
    if (mediaId && typeof gallery?.setActiveMedia === 'function') {
      gallery.setActiveMedia(root.dataset.section + '-' + mediaId, false, true);
    }
  }
  document.addEventListener('change', event => {
    const input = event.target.closest('input[data-lumis-group]');
    if (input) latest.set(input.closest('product-info')?.dataset.section, input.dataset.lumisGroup);
  });
  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.variantChange, event => {
      const root = document.querySelector('product-info[data-section="' + event.data.sectionId + '"]');
      if (root) activate(root, latest.get(event.data.sectionId));
    });
  }
  const boot = () => document.querySelectorAll('product-info').forEach(root => activate(root));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true}); else boot();
})();